import React from 'react';
import SectionCard from './SectionCard';
import ReadonlyField from './ReadonlyField';

const ImportantDatesSection = ({ submission, jsonContent, isDark }) => {
    const fields = [
        { field: 'last_agm_date', label: 'Last AGM Date' },
        { field: 'last_egm_date', label: 'Last EGM Date' },
        { field: 'last_committee_date', label: 'Last Committee Date' },
    ];

    return (
        <>
            {fields.map(({ field, label }) => {
                const val = submission[field] || jsonContent[field];
                if (!val) return null;
                
                const formatValue = (s) => {
                    const strVal = String(s);
                    const [date, time] = strVal.split('T'); 
                    if (!date) return strVal; 
                    const [y, m, d] = date.split('-'); 
                    if (!time) return `${m}/${d}/${y}`; 
                    const [hStr, min] = time.split(':'); 
                    const h = parseInt(hStr, 10); 
                    const ampm = h >= 12 ? 'PM' : 'AM'; 
                    const h12 = h % 12 || 12; 
                    return `${m}/${d}/${y} ${String(h12).padStart(2, '0')}:${min} ${ampm}`;
                };

                return (
                    <SectionCard key={field} isDark={isDark}>
                        <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                            isDark ? 'text-white' : 'text-[#072837]'
                        }`}>{label}</p>
                        <input
                            className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                                isDark ? 'bg-[#161515] text-white' : 'bg-[#f5f5f5] text-[#072837]'
                            }`}
                            type="text"
                            value={formatValue(val)}
                            readOnly
                        />
                    </SectionCard>
                );
            })}
        </>
    );
};

export default ImportantDatesSection;
